import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { mockPosts } from '../data';

const PostView: React.FC = () => {
  const { postId } = useParams<{ postId: string }>();
  const navigate = useNavigate();
  
  const post = mockPosts.find(p => p.id === postId);

  useEffect(() => {
    if (post) {
      // Redirect to the topic view with the post's topic
      navigate(`/topic/${post.topicId}`, { replace: true });
    } else {
      // If post not found, redirect to home
      navigate('/', { replace: true });
    }
  }, [post, navigate]);

  return (
    <div className="loading">
      Redirecting...
    </div>
  );
};

export default PostView; 